import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { concatMap, mergeMap, withLatestFrom } from 'rxjs/operators';
import * as merch from '@webapp/sdk/merch';
import { Actions } from '../../actions';
import {
  FinishMerchLater,
  FinishMerchLaterError,
  FinishMerchLaterSuccess,
  RedirectToCatalogPage,
  UpdateMerchError,
} from '../action-creators';
import { FINISH_MERCH_LATER } from '../actions';
import AppState from '../../state';
import { createMerchRequest } from '../selectors';

export const finishMerchLaterEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, FinishMerchLater>(FINISH_MERCH_LATER),
    withLatestFrom(state$),
    mergeMap(async ([_, state]) => {
      try {
        const artistId = state.artist.active?.id;
        const productId =
          state.merch.active?.editProduct?.id ||
          state.merch.active?.newProduct?.productId;

        if (!!artistId && !!productId) {
          const request = createMerchRequest(state.merch);
          await merch.editMerch(request, productId, artistId);
        }

        return [
          new RedirectToCatalogPage('merch', 'draft'),
          new FinishMerchLaterSuccess(),
        ];
      } catch (err) {
        return [
          new UpdateMerchError(err.message),
          new FinishMerchLaterError(err.message),
        ];
      }
    }),
    concatMap((actions) => actions)
  );
